import { useState } from "react";
import LazyLoad from "react-lazyload";
import PropTypes from "prop-types";
import { componentCheckSize } from "../../../utils/helperServices";
import {
  numberFormat,
  getdealDatenVariant,
} from "../../../utils/helperServices";
import { CustomContainer, TextTruncate } from "../../atoms/DependencyHelper";
import ButtonComponent from "../../atoms/button/ButtonComponent";
import Tag from "../../atoms/tag/Tag";
import ImageWithText from "../../atoms/imageWithText/ImageWithText";
import Timer from "../../atoms/timer/Timer";
import styles from "./DealCard.module.scss";

const DealCard = (props) => {
  const [isTimerOn, setIsTimerOn] = useState(true);
  const handleTimerChange = (newValue) => {
    setIsTimerOn(newValue);
  };

  const [dateTime, dealVariant] = getdealDatenVariant(props);
  const isMobile = componentCheckSize() < 992;

  const buttonHandler = (e) => {
    if (
      dealVariant === "comingSoon" ||
      dealVariant == "hidden" ||
      dealVariant == "Expired" ||
      props?.isOutOfStock
    ) {
      e.stopPropagation();
      e.preventDefault();
      return;
    }

    if (props.buttonHandler) {
      props.buttonHandler(props?.item);
    }
  };

  const textTruncate = (str, length, ending) => {
    if (length == null) {
      length = 100;
    }
    if (ending == null) {
      ending = "...";
    }
    if (str.length > length) {
      return str.substring(0, length - ending.length) + ending;
    } else {
      return str;
    }
  };

  return (
    <>
      <CustomContainer
        style={{
          width: isMobile
            ? props?.width_mobile
            : props.campaignFlag == true && window.outerWidth > 1440
            ? "100%"
            : props.width,
          maxHeight: props.maxHeight,
        }}
        className={`${styles["deal-card"]} ${props.className} ${
          props?.isOutOfStock ||
          dealVariant === "Expired" ||
          (dealVariant &&
            isTimerOn &&
            (dealVariant == "locked" ||
              dealVariant == "hidden" ||
              dealVariant === "comingSoon"))
            ? `${styles["product-card-non-clickable"]}`
            : ""
        } ${styles[props.className]}`}
        id="Deal-Card"
        onClick={buttonHandler}
      >
        <CustomContainer
          className={
            styles[props.saveLabel ? "badge-extended" : "badges-section"]
          }
        >
          {props.saveLabel && (
            <CustomContainer className={styles["discount-text"]}>
              {"SAVE R"}
              {props.saveLabel}
            </CustomContainer>
          )}

          <CustomContainer className={`${styles["promotion-container"]}`}>
            {!props?.isOutOfStock &&
              dealVariant &&
              dealVariant != "locked" &&
              isTimerOn && (
                <CustomContainer
                  className={`${styles["timer-section-badge"]} ${
                    styles["tag-style"]
                  }
                    ${
                      styles[
                        dealVariant === "specialDeals"
                          ? "timer-section-badge-red"
                          : "timer-section-badge-green"
                      ]
                    }
                  `}
                >
                  <Timer
                    preText={
                      dealVariant === "specialDeals" ? "Ends in " : "Starts in "
                    }
                    dateTime={dateTime}
                    onTimerComplete={handleTimerChange}
                  />
                </CustomContainer>
              )}
            {props.promotionLabel && (
              <Tag
                label={props.promotionLabel}
                variant={props.promotionVariant}
                labelColor={props.promotionLabelColor}
                className={styles["tag-style"]}
              />
            )}
          </CustomContainer>

          {props?.isOutOfStock && (
            <CustomContainer>
              <CustomContainer
                className={`${styles["DisabledOverlay"]}`}
              ></CustomContainer>
              <CustomContainer className={`${styles["ExpiredSoldOutBanner"]} `}>
                SOLD OUT
              </CustomContainer>
            </CustomContainer>
          )}

          {dealVariant === "Expired" && (
            <CustomContainer>
              <CustomContainer
                className={`${styles["DisabledOverlay"]}`}
              ></CustomContainer>
              <CustomContainer className={`${styles["ExpiredSoldOutBanner"]} `}>
                DEAL ENDED
              </CustomContainer>
            </CustomContainer>
          )}
        </CustomContainer>

        <CustomContainer className={styles["content-section"]}>
          <CustomContainer className={styles["image-section"]}>
            {!props?.noLazyload ? (
              <LazyLoad debounce={200} scroll={true}>
                <ImageWithText
                  imageLabelStyle={`${styles["image-text-content"]} `}
                  text={textTruncate(props.productName, 55)}
                  color={props?.isDealDetailPage ? props?.color : false}
                  img_path={isMobile ? props.imgUrl_mobile : props.imgUrl}
                  width={isMobile ? props.img_width_mobile : props.img_width}
                  height={isMobile ? props.img_height_mobile : props.img_height}
                >
                  <TextTruncate
                    containerClassName={`${styles["image-text-content"]}`}
                    className="title"
                    line={2}
                    element="div"
                    truncateText="…"
                    text={props.productName}
                  />
                </ImageWithText>
              </LazyLoad>
            ) : (
              <ImageWithText
                imageLabelStyle={`${styles["image-text-content"]} `}
                text={textTruncate(props.productName, 55)}
                color={props?.isDealDetailPage ? props?.color : false}
                img_path={isMobile ? props.imgUrl_mobile : props.imgUrl}
                width={isMobile ? props.img_width_mobile : props.img_width}
                height={isMobile ? props.img_height_mobile : props.img_height}
              ></ImageWithText>
            )}
            {props.addnlComment && (
              <CustomContainer className={styles["extra-text"]}>
                {props.addnlComment}
              </CustomContainer>
            )}
          </CustomContainer>
          {!props.hideDetails && (
            <CustomContainer className={styles["description-section"]}>
              <CustomContainer className={styles["highlight-section"]}>
                {props.highlights.length > 0 && (
                  <CustomContainer
                    className={`${
                      styles[
                        props.highlights.length > 1
                          ? "left-container"
                          : "centered-container"
                      ]
                    }`}
                  >
                    <CustomContainer className={styles["highlight-value"]}>
                      {props.highlights[0].value}
                    </CustomContainer>
                    <CustomContainer className={styles["highlight-type"]}>
                      {props.highlights[0].displayUnit}
                    </CustomContainer>
                  </CustomContainer>
                )}
                {props.highlights?.length > 1 && (
                  <CustomContainer
                    className={`flex-column ${styles["connector"]}`}
                  >
                    <CustomContainer className={styles["hyphen"]}>
                      |
                    </CustomContainer>
                    <CustomContainer className={styles["ampersand"]}>
                      &
                    </CustomContainer>
                    <CustomContainer className={styles["hyphen"]}>
                      |
                    </CustomContainer>
                  </CustomContainer>
                )}
                {props.highlights?.length > 1 && (
                  <CustomContainer className={`${styles["left-container"]}`}>
                    <CustomContainer className={styles["highlight-value"]}>
                      {props.highlights[1]?.value}
                    </CustomContainer>
                    <CustomContainer className={styles["highlight-type"]}>
                      {props.highlights[1]?.displayUnit}
                    </CustomContainer>
                  </CustomContainer>
                )}
              </CustomContainer>
            </CustomContainer>
          )}

          {props.originalPrice || props.offerPrice || props.prevPrice ? (
            <CustomContainer className={styles["price-section"]}>
              {props.originalPrice && !props.saveLabel && !props.prevPrice ? (
                <CustomContainer className={styles["original-price"]}>
                  {`for only R${numberFormat(Math.round(props.originalPrice))}`}{" "}
                  {props.numberOfMonths ? `PM x ${props.numberOfMonths}` : ""}
                </CustomContainer>
              ) : (
                ""
              )}

              {props.prevPrice ? (
                <CustomContainer className={styles["offer-price"]}>
                  {`Now only R${numberFormat(Math.round(props.offerPrice))}`}
                  {props.numberOfMonths ? ` PM x ${props.numberOfMonths}` : ""}
                </CustomContainer>
              ) : (
                ""
              )}

              {props.prevPrice ? (
                <CustomContainer className={styles["prev-price"]}>
                  {`Was R${numberFormat(Math.round(props.prevPrice))}`}
                  {props.numberOfMonths ? ` PM x ${props.numberOfMonths}` : ""}
                </CustomContainer>
              ) : (
                ""
              )}
            </CustomContainer>
          ) : (
            <CustomContainer className={styles["price-section"]} />
          )}
        </CustomContainer>

        {props.hideButton ? (
          <CustomContainer className="mb-s" />
        ) : (
          <CustomContainer
            className={
              dealVariant &&
              isTimerOn &&
              (dealVariant == "locked" || dealVariant == "hidden")
                ? styles["button-section-greyed"]
                : styles["button-section"]
            }
            id={`${props.buttonText}-btn-deals`}
          >
            <ButtonComponent
              button
              textClassName={
                dealVariant &&
                isTimerOn &&
                (dealVariant == "locked" ||
                  dealVariant == "hidden" ||
                  dealVariant === "comingSoon")
                  ? styles["greyed-button"]
                  : ""
              }
              text={
                (dealVariant === "comingSoon" && "Coming soon") ||
                props.buttonText
              }
            />
          </CustomContainer>
        )}

        {dealVariant &&
        dealVariant == "locked" &&
        isTimerOn &&
        !props.isOutOfStock ? (
          <CustomContainer
            className={`${styles["timer-section"]} ${styles["locked-timer"]}`}
          >
            <CustomContainer
              className={styles["timer-inner"]}
              id={`${props.deal_label}-locked-container`}
            >
              <CustomContainer
                className={styles["timer-lock-image"]}
                id="timerLock-image-DC"
              />
              <CustomContainer
                className={styles["timer-text"]}
                id={`${props.deal_label}-locked-text`}
              >
                {props.deal_label}
              </CustomContainer>
              <Timer dateTime={dateTime} onTimerComplete={handleTimerChange} />
            </CustomContainer>
          </CustomContainer>
        ) : (
          ""
        )}
      </CustomContainer>
    </>
  );
};

DealCard.propTypes = {
  width: PropTypes.string.isRequired,
  img_width: PropTypes.string.isRequired,
  img_height: PropTypes.string.isRequired,
  width_mobile: PropTypes.string,
  img_width_mobile: PropTypes.string.isRequired,
  img_height_mobile: PropTypes.string.isRequired,
  productName: PropTypes.string,
  imgUrl: PropTypes.string,
  saveLabel: PropTypes.string,
  promotionLabel: PropTypes.string,
  addnlComment: PropTypes.string,
  planName: PropTypes.string,
  highlights: PropTypes.array,
  originalPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  offerPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  prevPrice: PropTypes.string,
  buttonText: PropTypes.string.isRequired,
  buttonHandler: PropTypes.func.isRequired,
  campaignFlag: PropTypes.bool,
  className: PropTypes.string,
  color: PropTypes.oneOfType([ // TODO: Fix, color cannot be bool
    PropTypes.bool,
    PropTypes.string
  ]),
  deal_label: PropTypes.string,
  hideButton: PropTypes.bool,
  hideDetails: PropTypes.bool,
  imgUrl_mobile: PropTypes.string,
  isDealDetailPage: PropTypes.bool,
  isOutOfStock: PropTypes.bool,
  item: PropTypes.any,
  maxHeight: PropTypes.string,
  noLazyload: PropTypes.bool,
  numberOfMonths: PropTypes.string,
  promotionLabelColor: PropTypes.string,
  promotionVariant: PropTypes.string,
};

export default DealCard;
